export default "__VITE_ASSET__a44ec41a__"